import type { ChangeEvent } from 'react';

import type { SortParams } from '@/constants/types';

import { Divider } from '@flintmint/web-shared/components/divider';
import { Search } from '@flintmint/web-shared/components/search';
import { SingleSelect } from '@flintmint/web-shared/components/single-select';
import { SortMenu } from '@flintmint/web-shared/components/sort-menu';

import styles from './archive-filters.module.scss';

export type ArchiveTypeId = 'all' | 'notes' | 'templates' | 'blocks' | 'userSources';

export const ArchiveFilters = (props: ArchiveFiltersProps) => {
  const { selectedType, onSelectedTypeChange, searchValue, onSearchChange, isSearching, menuSort, onSort, onSearchSort } = props;

  return (
    <section className={styles.archiveFilters}>
      <SingleSelect
        showIcon={false}
        popoverProps={{
          width: 190,
          arrow: true,
          offset: [0, 15],
          placement: 'bottom',
        }}
        appearance="action-bar"
        options={[
          {
            icon: 'dashboard-circle',
            name: 'All',
            displayName: 'All files',
            selected: selectedType === 'all',
            onClick: () => onSelectedTypeChange('all'),
          },
          { type: 'divider' },
          {
            icon: 'note-01',
            name: 'Notes',
            selected: selectedType === 'notes',
            onClick: () => onSelectedTypeChange('notes'),
          },
          { type: 'divider' },
          {
            icon: 'note',
            name: 'Templates',
            selected: selectedType === 'templates',
            onClick: () => onSelectedTypeChange('templates'),
          },
          { type: 'divider' },
          {
            icon: 'blockchain-01',
            name: 'Blocks',
            selected: selectedType === 'blocks',
            onClick: () => onSelectedTypeChange('blocks'),
          },
          { type: 'divider' },
          {
            icon: 'ai-brain-01',
            name: 'Blueprints',
            selected: selectedType === 'userSources',
            onClick: () => onSelectedTypeChange('userSources'),
          },
        ]}
      />
      <div>
        <Search value={searchValue} onChange={(e: ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)} />
        <Divider orientation="vertical" size={24} />
        <SortMenu
          iconSize={20}
          onSort={isSearching ? onSearchSort : onSort}
          showName={false}
          showArrow={false}
          sort={menuSort}
          showRelevanceSort={isSearching}
        />
      </div>
    </section>
  );
};

interface ArchiveFiltersProps {
  searchValue: string;
  isSearching: boolean;
  selectedType: ArchiveTypeId;
  menuSort: SortParams | null;
  onSort: (sort: SortParams) => void;
  onSearchChange: (value: string) => void;
  onSearchSort: (sort: SortParams) => void;
  onSelectedTypeChange: (type: ArchiveTypeId) => void;
}
